module.exports = __webpack_public_path__ + "static/media/3.e8321e58.png";